import NoteAttachment from './NoteAttachment';

class Note {
  id: number;
  title: string = '';
  text: string = '';
  groupId: number;
  memberId: number;
  created: number;
  updated: number;
  checkers: number[];
  notify: boolean = false;
  attachment: NoteAttachment;
  notifiedMembersId: number[];
}

export default Note;



// WEBPACK FOOTER //
// ./src/entities/Note.ts